import { handleActions } from 'redux-actions';
import merge from 'lodash/merge';

import { TYPE } from './actions';

const reducer = handleActions(
    {
        // FETCH_BALANCE_REPORT
        [TYPE.FETCH_REMAINDERS_REPORT_LOADING]: (state) => {
            return {
                ...state,
                loading: true
            };
        },
        [TYPE.FETCH_REMAINDERS_REPORT_SUCCESS]: (state, action) => {
            const { content, first, last, size, number } = action.payload;
            return {
                ...state,
                data: content,
                pagination: {
                    first,
                    last,
                    size,
                    page: number
                },
                loading: false
            };
        },
        [TYPE.FETCH_REMAINDERS_REPORT_ERROR]: (state, action) => {
            return {
                ...state,
                data: [],
                loading: false,
                error: action.payload
            };
        },
        // FETCH_BALANCE_REPORT
        [TYPE.FETCH_TOTAL_REMAINDERS_LOADING]: (state) => {
            return {
                ...state,
                loading: true
            };
        },
        [TYPE.FETCH_TOTAL_REMAINDERS_SUCCESS]: (state, action) => {
            const { total, amount } = action.payload;
            return {
                ...state,
                total,
                amount,
                loading: false
            };
        },
        [TYPE.FETCH_TOTAL_REMAINDERS_ERROR]: (state, action) => {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        },
    },
    {
        loading: false,
        data: [],
        error: null,
        pagination: {
            first: true,
            last: false,
            size: 30,
            page: 0
        },
        filters: {
            startDate: '',
            endDate: '',
            type: '',
            terminal: '',
            searchQuery: '',
        },
    }
);

export default reducer;
